import { Injectable } from '@angular/core';
import { Api } from '../providers';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/fromPromise';
import 'rxjs/add/operator/mergeMap';
import {
    PostCreate,
    CommentCreate,
    WallCastConfig,
} from '../../models/post.model';
import { Subject } from 'rxjs';

/*
  Generated class for the EventWallProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class EventWallProvider {
    constructor(private api: Api) { }

    reloadPosts$ = new Subject();

    loadPosts() {
        this.reloadPosts$.next();
    }

    subscribeToPostsReload(callback: any) {
        return this.reloadPosts$.subscribe(data => {
            callback(data);
        })
    }

    createPost(body: PostCreate): Observable<any> {
        return this.api.post('posts/create', body).map(res => {
            return res;
        });
    }

    updatePost(body: PostCreate): Observable<any> {
      return this.api.post('posts/update', body).map(res => {
          return res;
      });
    }

    createComment(body: CommentCreate): Observable<any> {
        return this.api.post('posts/comment/create', body).map(res => {
            return res;
        });
    }

    getPosts(
        event: string,
        pageNumber: number,
        pageSize: number,
        postT?: string
    ): Observable<any> {
        return this.api
            .get('posts/findAll', {
                postType: postT,
                event: event,
                pageNumber: pageNumber,
                pageSize: pageSize,
            })
            .map(res => {
                return res;
            });
    }

    getQA(event: string, pageNumber: number, pageSize: number): Observable<any> {
        return this.api
            .get('posts/findAll', {
                postType: 'Q_AND_A',
                event: event,
                pageNumber: pageNumber,
                pageSize: pageSize,
            })
            .map(res => {
                return res;
            });
    }

    getVideo(event: string, pageNumber: number, pageSize: number): Observable<any> {
        return this.api
            .get('posts/findAll', {
                postType: 'VIDEO',
                event: event,
                pageNumber: pageNumber,
                pageSize: pageSize,
            })
            .map(res => {
                return res;
            });
    }

    getVoting(
        event: string,
        pageNumber: number,
        pageSize: number
    ): Observable<any> {
        return this.api
            .get('posts/findAll', {
                postType: 'VOTING',
                event: event,
                pageNumber: pageNumber,
                pageSize: pageSize,
            })
            .map(res => {
                return res;
            });
    }

    getPrizeGame(
        event: string,
        pageNumber: number,
        pageSize: number
    ): Observable<any> {
        return this.api
            .get('posts/findAll', {
                postType: 'PRIZE_GAME',
                event: event,
                pageNumber: pageNumber,
                pageSize: pageSize,
            })
            .map(res => {
                return res;
            });
    }

    likeOrUnlike(
        eventId: string,
        postId: string,
        like: boolean
    ): Observable<any> {
        return this.api
            .post('posts/like/createOrRemove', {
                eventUuid: eventId,
                postId: postId,
                like: like,
            })
            .map(res => {
                return res;
            });
    }

    likeOrUnlikeComment(
        eventId: string,
        postId: string,
        commentId: string,
        like: boolean
    ): Observable<any> {
        return this.api
            .post('posts/comment/like/createOrRemoveLikeOnComment', {
                eventUuid: eventId,
                postId: postId,
                commentId: commentId,
                like: like,
            })
            .map(res => {
                return res;
            });
    }

    removeCommentPost(
        eventId: string,
        postId: number,
        commentId: number
    ): Observable<any> {
        return this.api
            .post('posts/comment/remove', {
                eventUuid: eventId,
                postId: postId,
                commentId: commentId,
            })
            .map(res => {
                return res;
            });
    }

    removePost(eventId: string, postId: string): Observable<any> {
        return this.api
            .post('posts/remove', {
                eventUuid: eventId,
                postId: postId,
            })
            .map(res => {
                return res;
            });
    }

    getPost(event: string, postId: number): Observable<any> {
        return this.api
            .get('posts/find', {
                event: event,
                postId: postId,
            })
            .map(res => {
                return res;
            });
    }

    getPostById(postId: number | string): Observable<any> {
      return this.api
          .get('posts/findPostById', {
              postId: postId,
          })
          .map(res => {
              return res;
          });
    }

    getComments(
        event: string,
        postId: number,
        pageNumber: number,
        pageSize: number
    ): Observable<any> {
        return this.api
            .get('posts/comment/findAll', {
                event: event,
                postId: postId,
                pageNumber: pageNumber,
                pageSize: pageSize,
            })
            .map(res => {
                return res;
            });
    }

    uploadImage(uploadedFile: any): Observable<any> {
        return Observable.fromPromise(
            this.api.fileUpload('image/upload', uploadedFile)
        ).mergeMap(res => {
            return res;
        });
    }

    castToWall(
        event: string,
        streamSort: string,
        pageSize: number
    ): Observable<any> {
        return this.api
            .get('wallstream/streamOfPosts', {
                event: event,
                streamSort,
                pageSize: pageSize,
            })
            .map(res => {
                return res;
            });
    }

    setWallCastConfig(body: WallCastConfig): Observable<any> {
        return this.api.post('wallstream/config', body).map(res => {
            return res;
        });
    }

    public announce(postId: string): Observable<any> {
        return this.api.post(`posts/announce/${postId}`, {}, {
            responseType: 'text',
          });
    }

    toggleAnswer(
      answered: boolean,
      commentId: number | string,
      eventUuid: string,
      postId: number | string
    ): Observable<any> {
        return this.api
            .post('posts/comment/answer/createAnswerOnComment', {
              answered,
              commentId,
              eventUuid,
              postId
            })
            .map(res => {
                return res;
            });
    }

    pinPost(
      pinned: boolean,
      eventUuid: string,
      postId: number | string
    ): Observable<any> {
        return this.api
            .post('posts/setPostPin', {
              pinned,
              eventUuid,
              postId
            })
            .map(res => {
                return res;
            });
    }
}



// WEBPACK FOOTER //
// ./src/providers/event-wall/event-wall.ts